import App from './App.vue';

export default {
  path: '/CDS_VF_StaffTable',
  name: 'CDS_VF_StaffTable',
  component: App,
  meta: {
    pageProperty: {
      title: '参集人員表',
      controller: 'CDS_CTR_StaffTable',
    },
  },
};
